import { type Schema, SchemaType } from "../../../core/render/logic/Markdoc/index";

export const hr: Schema = {
	render: "hr",
	type: SchemaType.block,
};
